<header class="gs-page-header">

  <!-- ── Desktop ── -->
  <div class="d-none d-lg-block">

    <!-- Ligne 1 : topbar actions à droite -->
    <div class="gs-top-bar">
      <div class="gs-top-bar-actions">
        <button class="gs-action-btn" [class.gs-action-btn-dys]="isDys" type="button" [title]="'Accessibilité' | translate" (click)="openAccessibility()">
          <i class="fa-solid fa-universal-access"></i>
        </button>
        <div class="gs-profile-wrapper" (clickOutside)="closeProfileDropdown()">
          <button class="gs-action-btn gs-action-btn-profile" type="button" title="Profil" (click)="toggleProfileDropdown()">
            <i class="fa-regular fa-user"></i>
          </button>
          <div class="gs-profile-dropdown" [class.open]="profileDropdownOpen">

            <div class="gs-profile-section">
              <div class="gs-profile-label" *ngIf="userName">{{ userName }}</div>
              <a class="gs-profile-item" (click)="goToProfile()">
                <i class="fa-regular fa-user"></i>
                <span translate>Mon compte</span>
              </a>
            </div>

            <div class="gs-profile-sep"></div>

            <div class="gs-profile-section">
              <div class="gs-profile-label" translate>Langue d'interface</div>
              <div class="gs-profile-flags">
                <button *ngFor="let lang of langSrcList"
                        class="gs-profile-flag"
                        [class.active]="lang.shortCode === langSrcSrv.current.shortCode"
                        (click)="changeLangSrc(lang)"
                        type="button">
                  <span class="gs-profile-flag-img">
                    <img src="assets/images/flags/{{lang.flag}}" [alt]="lang.name"/>
                  </span>
                  <span class="gs-profile-flag-code">{{ lang.shortCode }}</span>
                </button>
              </div>
            </div>

            <div class="gs-profile-sep"></div>

            <div class="gs-profile-section">
              <a class="gs-profile-item" (click)="logout()">
                <i class="fa-solid fa-right-from-bracket"></i>
                <span translate>Déconnexion</span>
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Ligne 2 : titre à gauche + pills à droite -->
    <div class="gs-nav-bar">
      <div class="gs-header-left">
        <div class="gs-section-label"><i class="fa-solid fa-gamepad"></i> SERIOUS <span class="gs-blue">GAME</span></div>
        <div class="gs-page-name">{{ currentPageLabel }}</div>
      </div>
      <nav class="gs-nav-pills">
        <a *ngFor="let item of navItems; trackBy: trackByIndex"
           class="gs-pill"
           [class.active]="isActiveItem(item)"
           (click)="navigateTo(item)">
          <i [class]="item.icon"></i>
          <span>{{ item.label }}</span>
        </a>
      </nav>
    </div>

  </div>

  <!-- ── Mobile breadcrumb pill + titre ── -->
  <div class="gs-mobile-header d-lg-none">
    <div class="gs-mobile-breadcrumb" (clickOutside)="closeMobileDropdown()">
      <button class="gs-mobile-pill" (click)="toggleMobileDropdown()" type="button">
        <i class="fa-solid fa-gamepad"></i>
        <span>Serious <strong>GAME</strong></span>
        <i class="fa-solid fa-chevron-right gs-mobile-sep"></i>
        <span class="gs-mobile-current">{{ currentPageLabel }}</span>
        <i class="fa-solid fa-caret-down gs-mobile-caret" [class.open]="mobileDropdownOpen"></i>
      </button>
      <ul class="gs-mobile-dropdown" [class.open]="mobileDropdownOpen">
        <li *ngFor="let item of navItems; trackBy: trackByIndex">
          <a (click)="navigateTo(item)" [class.active]="isActiveItem(item)">
            <i [class]="item.icon"></i>
            {{ item.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="gs-mobile-title">
      <div class="gs-mobile-section-label"><i class="fa-solid fa-gamepad"></i> SERIOUS <span>GAME</span></div>
      <div class="gs-mobile-page-name">{{ currentPageLabel }}</div>
    </div>
  </div>

</header>
